import { FC } from 'react'
import { Box } from '@stoplight/mosaic'

import { generateRandomInteger } from '../utils/content'

export const ContentLoader: FC<{ numberOfParagraphs?: number }> = ({
  numberOfParagraphs = 4,
}) => {
  const headerWidth = generateRandomInteger(450, 600)
  const subheaderWidth = generateRandomInteger(600, 750)

  const generateParagraphWordCount = () => generateRandomInteger(20, 30)
  const generateWordWidth = () => generateRandomInteger(40, 160)

  const paragraphs = [...Array(numberOfParagraphs)].map(() => {
    return [...Array(generateParagraphWordCount())].map(generateWordWidth)
  })

  return (
    <div className="content-loader">
      <Box
        bg="canvas-100"
        mt={2}
        style={{ width: `${headerWidth}px`, height: '42px' }}
        className="content-loader-header"
      />
      <Box
        bg="canvas-100"
        mt={3}
        mb={12}
        style={{ width: `${subheaderWidth}px`, height: '28px' }}
        className="content-loader-subheader"
      />
      {paragraphs.map((wordWidths, index) => (
        <Paragraph key={index} wordWidths={wordWidths} />
      ))}
      <div className="content-loader-overlay" />
    </div>
  )
}

const Paragraph: FC<{ wordWidths: Array<number> }> = ({ wordWidths }) => (
  <Box mb={6}>
    {wordWidths.map((width, index) => (
      <Word key={index} height={18} width={width} />
    ))}
  </Box>
)

const Word: FC<{ height: number; width: number }> = ({ height, width }) => (
  <Box
    bg="canvas-100"
    mb={2}
    style={{ display: 'inline-block', height: `${height}px`, width }}
  />
)
